import { api, apiAuth, apiResponseType } from ".";

export const getToken = (data: any): apiResponseType =>
  api.post("/login", data);

export const userData = (): apiResponseType => apiAuth.get("/clients/select");

export const getUsers = (page: number, params) =>
  apiAuth.get("/users", {
    params: {
      page,
      ...params,
    },
  }) as apiResponseType;

export const insertUser = (data) =>
  apiAuth.post("/users/store", data) as apiResponseType;
export const deleteUser = (uuid: string) =>
  apiAuth.delete(`/users/${uuid}/destroy`) as apiResponseType;
export const updateUser = (uuid: string, data) =>
  apiAuth.put(`/users/${uuid}/update`, data) as apiResponseType;

export const forgetPassword = (email: string) =>
  apiAuth.post(`forget-password`, { email }) as apiResponseType;

export const selectUsers = (params: { name?: string } = {}) =>
  apiAuth.get(`users/select`, {
    params,
  }) as apiResponseType;

export const getMe = () =>
  apiAuth.get(`me`) as apiResponseType;
